{
  "verified": "Verificado",
  "iv_status": {
    "verified": "Verificado",
    "pending": "Pendiente",
    "attention": "Atención"
  },
  "zoom_in": "Ampliar",
  "zoom_out": "Alejar",
  "rotate": "Gire",
  "close": "Cerrar",
  "esc_to_close": "Pulse ESC para cerrar",
  "play": "Jugar",
  "pause": "Pausa",
  "mute": "Silenciar",
  "unmute": "Desactivar",
  "enter_full_screen": "Entrar en pantalla completa",
  "exit_full_screen": "Salir a pantalla completa",
  "video_not_supported": "Su navegador no soporta la etiqueta de vídeo.",
  "skip_forward": "Saltar adelante",
  "skip_backward": "Saltar hacia atrás",
  "loading": "Cargando",
  "loading_video": "Cargando vídeo...",
  "loading_data_description": "Espere mientras cargamos sus datos. No tardaremos mucho.",
  "no_results": "Sin resultados",
  "nothing_found": "No se encontró nada",
  "save_changes": "Guardar cambios",
  "saved_exclamation": "¡Salvado!",
  "saving": "Guardar",
  "validating": "Validando",
  "error": "Error",
  "optional": "Opcional",
  "search_property": "Buscar inmuebles",
  "reset_search": "Restablecer búsqueda",
  "no_items_to_show": "No hay artículos que mostrar",
  "showing_range_of_total_items": "Mostrando {{range}} de {{total}} artículos",
  "rows_per_page": "Filas por página",
  "page_of_pages": "Página {{page}} de {{pages}}",
  "go_to_first_page": "Ir a la primera página",
  "go_to_previous_page": "Ir a la página anterior",
  "go_to_next_page": "Ir a la página siguiente",
  "go_to_last_page": "Ir a la última página",
  "sort_in_asc": "Ordenación ascendente",
  "sort_in_desc": "Orden descendente",
  "clear_sorting": "Clasificación clara",
  "sort_a_z": "Ordenar A → Z",
  "sort_z_a": "Ordenar Z → A",
  "reach_us_at_email": "Contáctanos por email support@chekin.com",
  "please_wait": "Espere, por favor",
  "feature_coming_soon": "Próximamente",
  "feature_coming_soon_description": "Esta funcionalidad está actualmente en desarrollo y estará disponible pronto. Manténgase atento para actualizaciones!",
  "beta": "Beta",
  "download_all": "Descargar todo",
  "entry_forms": "Formularios de inscripción",
  "tutorial": "Tutorial",
  "liveness_video": "Vídeo de prueba de vida",
  "reviews": "Reseñas",
  "learn_more": "Más información",
  "this_cannot_be_reverted": "This cannot be reverted",
  "delete": "Delete",
  "cancel": "Cancel",
  "you_have_made_changes": "You have made changes",
  "would_you_like_to_save_them": "Would you like to save them?",
  "save": "Save",
  "dont_save": "Don't save",
  "copied_exclamation": "¡Copiado!",
  "search_placeholder": "Busca...",
  "type_to_search": "Escriba para buscar...",
  "loading_more": "Cargando...",
  "no_options": "Sin opciones",
  "select_option": "Seleccionar opción",
  "clear_all": "Borrar todo",
  "remove_item": "Eliminar {{label}}",
  "upload_file": "Cargar archivo",
  "download_attachment": "Descargar archivo adjunto",
  "remove_file": "Eliminar archivo",
  "open_calendar": "Calendario abierto",
  "clear_dates": "Borrar fechas",
  "select_dates": "Seleccione las fechas",
  "pick_date_range": "Elija un intervalo de fechas",
  "from": "En",
  "to": "A",
  "pick_month": "Elige un mes",
  "pick_date": "Elige una fecha",
  "month": "Mes",
  "day": "Día",
  "year": "Año",
  "done": "Hecho",
  "wrong_period_of_dates": "El periodo seleccionado no es válido",
  "date_range_max_days_error_one": "El intervalo no puede ser superior a {{count}} día",
  "date_range_max_days_error_other": "El intervalo no puede superar los {{count}} días",
  "date_range_min_days_error_one": "El intervalo debe ser de al menos {{count}} día",
  "date_range_min_days_error_other": "El intervalo debe ser de al menos {{count}} días",
  "past_dates": "La fecha no puede ser anterior a {{minDate}}.",
  "future_dates": "La fecha no puede ser posterior a {{maxDate}}.",
  "signature_placeholder_text": "Firma dentro de esta caja.<br/>Usa tu dedo.<br/>Toca para empezar.",
  "open_devices_camera": "Abrir la cámara del dispositivo",
  "place_document_inside_frame": "Coloque el documento dentro del marco",
  "close_other_application_that_may_be_using_your_camera": "Cierra otras aplicaciones que puedan estar utilizando tu cámara",
  "if_you_use_external_camera_disconnect_and_reconnect": "Si utilizas una cámara externa, desconéctala y vuelve a conectarla",
  "close_the_browser_re_open_it": "Cierre el navegador y vuelva a abrirlo",
  "camera_errors": {
    "experiencing_camera_issues": "¿Tienes problemas con la cámara?",
    "chekin_cant_use_your_camera": "Chekin no puede usar tu cámara",
    "please_try_a_different_browser": "Tu cámara no funciona en este navegador. Por favor, intente abrir el enlace en otro navegador.",
    "permissions_denied": "Permiso denegado",
    "camera_permissions_denied": "¿La cámara no se abre? Asegúrate de dar permiso al navegador para usar la cámara.",
    "no_camera_device_found": "No se ha encontrado ningún dispositivo de cámara. Por favor, conecte una cámara.",
    "constraints_camera_error": "Los dispositivos disponibles no pueden satisfacer las restricciones.",
    "safari_camera_error": "Safari no pudo satisfacer los requisitos de la cámara",
    "try_chrome_or_firefox": "Pruebe Chrome o Firefox"
  },
  "clear": "Claro",
  "show_less": "Mostrar menos",
  "show_more": "Ver más",
  "tap_here_to_sign": "Pulse aquí para firmar",
  "click_here_to_sign": "Pulse aquí para firmar",
  "prefix": "Prefijo",
  "prefix_required": "Prefijo obligatorio",
  "reset": "Restablecer",
  "show_password": "Mostrar contraseña",
  "hide_password": "Ocultar contraseña",
  "increment": "Incremento",
  "decrement": "Disminución",
  "create_option": "Crear \"{{input}}\"",
  "year_out_of_range": "El año debe estar comprendido entre {{min}} y {{max}}.",
  "clear_date": "Fecha clara",
  "select_date": "Seleccione la fecha",
  "draw_signature_here": "Firma aquí",
  "signature_hint": "Usa el ratón o el dedo",
  "clear_signature": "Firma clara",
  "draw_signature_here_mobile": "Escribe tu firma",
  "signature_hint_mobile": "Usa el dedo",
  "camera_access_needed": "Se necesita acceso a la cámara",
  "camera_access_needed_text": "Permite el acceso a la cámara para hacer la foto. Si está bloqueado, habilita la cámara en la configuración de tu navegador y vuelve a intentarlo.",
  "dialog": "Diálogo"
}
